export default "__VITE_ASSET__CWt_UF0k__"